import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/PageHeader';
import { useCurrentUser } from '@/hooks';
import { CalendarActivitiesStaticBlock } from '@/views/CalendarActivities';
import { RecentAccountsStaticBlock } from '@/views/Homepage';

export const Homepage = () => {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUser();

  const showRecentHistory = currentUser?.permissions?.common?.canReadHistory;

  return (
    <StyledGrid container spacing={{ xs: 2, md: 3 }}>
      <Grid size={{ xs: 12, md: showRecentHistory ? 12 : 8 }}>
        <PageHeader title={t('pages.homepage.dashboard')} />
      </Grid>

      <Grid size={{ xs: 12, md: 8 }}>
        <CalendarActivitiesStaticBlock />
      </Grid>

      {showRecentHistory && (
        <Grid container direction="column" spacing={3} size={{ xs: 12, md: 4 }}>
          <Grid>
            <RecentAccountsStaticBlock />
          </Grid>
        </Grid>
      )}
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
});
